import { useQuery } from "@tanstack/react-query";
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { FilterContext } from "./Filter";
import {
  avgKmTable,
  avgKmWiseVehicle,
  firstPurchaseDate,
  lastPurchaseDate,
  productLineWiseBoxes,
  stateGraphData,
  stateVehicleCountData,
} from "../pages/Vehicle/VechicleKpi";

export const VehicleContext = createContext();

const VehicleDataProvider = ({ children }) => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  

  const values = {
  };

  return (
    <VehicleContext.Provider value={values}>
      {children}
    </VehicleContext.Provider>
  );
};

export default VehicleDataProvider;
